import { render, staticRenderFns } from "./DropdownFilterAltResults.vue?vue&type=template&id=0058d2d3&scoped=true&"
import script from "./DropdownFilterAltResults.vue?vue&type=script&lang=ts&"
export * from "./DropdownFilterAltResults.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownFilterAltResults.vue?vue&type=style&index=0&id=0058d2d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0058d2d3",
  null
  
)

export default component.exports